import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = { target: String } // ISO timestamp of the next run

  connect() {
    this.tick()
    this.intervalId = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.intervalId)
  }

  tick() {
    const target = new Date(this.targetValue)
    const now = new Date()
    const diff = target - now

    if (!this.hasDisplayTarget) return

    if (isNaN(target.getTime()) || diff <= 0) {
      this.displayTarget.textContent = "Running soon"
      return
    }

    const days    = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    if (days > 0) {
      this.displayTarget.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`
    } else if (hours > 0) {
      this.displayTarget.textContent = `${hours}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`
    } else {
      this.displayTarget.textContent = `${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`
    }
  }
}
